export const AUTH_USER = 'AUTHENTICATION_USER';
export const AUTH_USER_FAILED = 'AUTHENTICATION_USER_FAILED';
export const GET_USER_IN_S = 'GET_USER_IN_SESSION';
export const LOGOUT_USER = 'LOGOUT_USER';
export const CHANGE_ROLE_USER = 'CHANGE_ROLE_USER';